import React from 'react';

import styled from 'styled-components';
import { TeamIconContainer } from 'styles/common';

import { TEAM_TYPE } from 'constants/ProjectConstants';
import { PinIcon } from 'constants/icons';
import theme from 'constants/theme';

const TeamTypeIcon = ({ show = false, teamType }) => (
  <>
    {show && teamType === TEAM_TYPE.preferred && (
      <TeamIconContainer>
        <IconWrapper>
          <PinIcon size="fixed12px" color={theme.palette.text.primaryBlue} />
        </IconWrapper>
      </TeamIconContainer>
    )}
  </>
);

const IconWrapper = styled.div`
  position: absolute;
  height: 15px;
  width: 15px;
  right: 25px;
  top: -16px;
`;

export default TeamTypeIcon;
